import { defineComponent as _defineComponent } from 'vue'
import { computed, CreateElement, getCurrentInstance, watch } from 'vue';
import { useWindowScroll } from '@vueuse/core';
import { useLanguageStore } from '@/helpers/composables/useStores';
import { useI18n } from '@/helpers/composables/useI18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'DisclaimerButton',
  props: {
    price: null,
    isDisneyPlusPromo: { type: Boolean },
    disclaimerText: null
  },
  setup(__props: any) {

const props = __props as { price: string; isDisneyPlusPromo?: boolean; disclaimerText?: string };



const instance = getCurrentInstance();
let popover: HTMLIonPopoverElement | null = null;

const { y } = useWindowScroll();
const { country } = useLanguageStore();

const acceptedCountries = ['MX', 'DE', 'US', 'CA', 'AU', 'UK', 'GB', 'IE', 'NZ', 'ZA'];

const showDisclaimer = computed(() => acceptedCountries.includes(country.value));

const { t, tc } = useI18n();

async function openDisclaimer() {
	const { popoverController } = await import('@/ionic.loader');
	popover = await popoverController.create({
		cssClass: 'disclaimer-popover',
		component: {
			render: (h: CreateElement) => {
				if (props.isDisneyPlusPromo && props.disclaimerText) {
					return h('div', { class: 'disclaimer-text' }, [h('span', props.disclaimerText)]);
				}

				return h('div', { class: 'disclaimer-text' }, [
					h('span', tc('WEBAPP_APPLE_DISCLAIMER_TEXT')),
					h('span', t('WEBAPP_APPLE_DISCLAIMER_SUB_TEXT', { price: props.price }) as string),
				]);
			},
		},
		componentProps: { parent: instance?.proxy, propsData: {} },
		event,
		mode: 'ios',
	});

	popover.present();

	popover.onDidDismiss().then(() => {
		popover = null;
	});
}

watch(y, () => {
	if (popover) {
		popover.dismiss();
	}
});

return { __sfc: true,props, instance, popover, y, country, acceptedCountries, showDisclaimer, t, tc, openDisclaimer }
}

})